const most = {
  name: 'most',
  translationKey: 'SYNC_WINDOW_MOST',
  params: {
    shifts_days_back: 90,
    shifts_days_forward: null,
    shifts_exclude_unactionable: false,
    claims_days_back: 90,
    claims_days_forward: null,
    claims_include_all_declined: true,
  },
};

const medium = {
  name: 'medium',
  translationKey: 'SYNC_WINDOW_MEDIUM',
  params: {
    ...most.params,
    shifts_days_back: 30,
    shifts_days_forward: 30,
    shifts_exclude_unactionable: true,
    claims_days_back: 30,
    claims_days_forward: 30,
    claims_include_all_declined: true,
  },
};

const minimal = {
  name: 'minimal',
  translationKey: 'SYNC_WINDOW_MINIMAL',
  params: {
    ...medium.params,
    shifts_days_back: 3,
    shifts_days_forward: 3,
    shifts_exclude_unactionable: true,
    claims_days_back: 3,
    claims_days_forward: 3,
    claims_include_all_declined: true,
  },
};

export const syncWindowDefinitions = {
  most,
  medium,
  minimal,
};

export const defaultSyncWindowDefinition = syncWindowDefinitions.medium;
